var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 47.6 48",
    style: {
      enableBackground: "new 0 0 47.6 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols"
  }, /*#__PURE__*/React.createElement("g", {
    id: "footer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st0",
    d: "M35.5,16.6c-0.9,0.4-1.8,0.7-2.8,0.8c1-0.6,1.8-1.6,2.2-2.8c-1,0.6-2,1-3.1,1.2 c-0.9-1-2.2-1.6-3.6-1.6c-2.7,0-4.9,2.3-4.9,5.1c0,0.4,0,0.8,0.1,1.2c-4.1-0.2-7.7-2.3-10.1-5.3c-0.4,0.8-0.7,1.6-0.7,2.6 c0,1.8,0.9,3.3,2.2,4.3c-0.8,0-1.6-0.3-2.2-0.6v0.1c0,0.7,0.1,1.3,0.3,1.9c0.6,1.6,2,2.8,3.6,3.2c-0.4,0.1-0.9,0.2-1.3,0.2 c-0.3,0-0.6,0-0.9-0.1c0.6,2,2.4,3.5,4.6,3.5c-1.7,1.4-3.8,2.2-6.1,2.2c-0.4,0-0.8,0-1.2-0.1c2.2,1.4,4.8,2.3,7.6,2.3 c7.7,0,12.4-5.6,13.7-11.5c0.2-1,0.3-2.1,0.3-3.1v-0.7C34,18.5,34.9,17.6,35.5,16.6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    className: "st0",
    d: "M23.9,48C10.7,48,0,37.2,0,24S10.7,0,23.9,0c1.6,0,3.2,0.2,4.8,0.5c0.9,0.2,1.7,0.4,2.6,0.7 c0.4,0.1,0.7,0.6,0.5,1c-0.1,0.4-0.6,0.7-1,0.5c-0.8-0.3-1.6-0.5-2.4-0.6c-1.5-0.3-3-0.5-4.5-0.5C11.6,1.6,1.6,11.7,1.6,24 s10,22.4,22.2,22.4S46,36.4,46,24c0-3.7-0.9-7.3-2.6-10.5c-0.2-0.4-0.1-0.9,0.3-1.1c0.4-0.2,0.9-0.1,1.1,0.3 c1.8,3.5,2.8,7.4,2.8,11.3C47.7,37.2,37,48,23.9,48"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    className: "st0",
    d: "M40.5,8.4c-0.2,0-0.4-0.1-0.5-0.3c-0.5-0.6-1.1-1.2-1.7-1.8c-0.5-0.4-0.9-0.8-1.4-1.2 c-0.4-0.3-0.4-0.8-0.2-1.2s0.7-0.5,1.1-0.2c0.5,0.4,1,0.8,1.5,1.3c0.6,0.6,1.3,1.2,1.8,1.9c0.3,0.3,0.3,0.9,0,1.3 C40.9,8.3,40.7,8.4,40.5,8.4"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/twitter-logo.78361c10b9dcadbc9d3cd4af17e66bc4.svg";
export { ForwardRef as ReactComponent };